export const landingPageTranslations = {
  pt: {
    hero: {
      badge: "A nova era dos links na bio",
      title: "Todos os seus links",
      titleHighlight: "em um lugar épico.",
      subtitle: "Crie uma página impressionante em segundos. Conecte sua audiência ao que realmente importa com uma experiência visual única e profissional.",
      cta: "Começar agora grátis",
      noCreditCard: "Sem cartão de crédito"
    },
    features: {
      ariaLabel: "Funcionalidades principais",
      items: [
        {
          title: "Um link para tudo",
          description: "Centralize sua presença digital. Instagram, TikTok, WhatsApp e muito mais em uma única página elegante."
        },
        {
          title: "Design Premium",
          description: "Personalize cada detalhe. Cores, fontes e estilos que combinam perfeitamente com a sua marca pessoal."
        },
        {
          title: "Analytics em Tempo Real",
          description: "Entenda seu público. Visualize cliques, visualizações e o desempenho de cada link instantaneamente."
        }
      ]
    },
    pricing: {
      badge: "Preços transparentes",
      title: "Escolha o plano perfeito para você",
      subtitle: "Comece grátis e evolua conforme sua audiência cresce. Sem taxas ocultas, cancele quando quiser.",
      monthly: "Mensal",
      annual: "Anual",
      perMonth: "/mês",
      perYear: "/ano",
      save: "Economize",
      perYearSuffix: "por ano!",
      mostPopular: "Mais popular",
      loading: "Carregando...",
      included: "Incluso:",
      guarantee: "Garantia de 30 dias. Cancele quando quiser, sem perguntas.",
      ariaLabel: "Planos e preços",
      plans: {
        free: {
          name: "Grátis",
          description: "Perfeito para começar sua jornada digital",
          cta: "Começar grátis",
          features: [
            "1 página de links",
            "Links ilimitados",
            "Métricas salvas por 7 dias",
            "Personalização básica de cores",
            "Analytics básico",
            "Suporte por email"
          ]
        },
        pro: {
          name: "Pro",
          description: "Para criadores que querem se destacar",
          cta: "Assinar agora",
          features: [
            "2 páginas de links",
            "Links ilimitados",
            "Métricas salvas por 30 dias",
            "Personalização completa de design",
            "Analytics avançado com gráficos",
            "Remover marca Hub Links",
            "Suporte por WhatsApp",
            "Temas premium exclusivos"
          ]
        },
        premium: {
          name: "Premium",
          description: "Para profissionais que exigem o máximo",
          cta: "Assinar agora",
          features: [
            "5 páginas de links",
            "Links ilimitados",
            "Métricas salvas por 365 dias (1 ano)",
            "Personalização completa de design",
            "Analytics avançado com gráficos",
            "Remover marca Hub Links",
            "Suporte por WhatsApp",
            "Integrações avançadas",
            "Relatórios personalizados"
          ]
        }
      }
    }
  },
  en: {
    hero: {
      badge: "The new era of bio links",
      title: "All your links",
      titleHighlight: "in one epic place.",
      subtitle: "Create a stunning page in seconds. Connect your audience to what really matters with a unique and professional visual experience.",
      cta: "Start for free",
      noCreditCard: "No credit card required"
    },
    features: {
      ariaLabel: "Main features",
      items: [
        {
          title: "One link for everything",
          description: "Centralize your digital presence. Instagram, TikTok, WhatsApp, and more in a single elegant page."
        },
        {
          title: "Premium Design",
          description: "Customize every detail. Colors, fonts, and styles that perfectly match your personal brand."
        },
        {
          title: "Real-time Analytics",
          description: "Understand your audience. Visualize clicks, views, and link performance instantly."
        }
      ]
    },
    pricing: {
      badge: "Transparent pricing",
      title: "Choose the perfect plan for you",
      subtitle: "Start for free and grow as your audience grows. No hidden fees, cancel anytime.",
      monthly: "Monthly",
      annual: "Annual",
      perMonth: "/month",
      perYear: "/year",
      save: "Save",
      perYearSuffix: "per year!",
      mostPopular: "Most popular",
      loading: "Loading...",
      included: "Included:",
      guarantee: "30-day guarantee. Cancel anytime, no questions asked.",
      ariaLabel: "Plans and pricing",
      plans: {
        free: {
          name: "Free",
          description: "Perfect to start your digital journey",
          cta: "Start for free",
          features: [
            "1 link page",
            "Unlimited links",
            "Metrics saved for 7 days",
            "Basic color customization",
            "Basic analytics",
            "Email support"
          ]
        },
        pro: {
          name: "Pro",
          description: "For creators who want to stand out",
          cta: "Subscribe now",
          features: [
            "2 link pages",
            "Unlimited links",
            "Metrics saved for 30 days",
            "Complete design customization",
            "Advanced analytics with charts",
            "Remove Hub Links branding",
            "WhatsApp support",
            "Exclusive premium themes"
          ]
        },
        premium: {
          name: "Premium",
          description: "For professionals who demand the maximum",
          cta: "Subscribe now",
          features: [
            "5 link pages",
            "Unlimited links",
            "Metrics saved for 365 days (1 year)",
            "Complete design customization",
            "Advanced analytics with charts",
            "Remove Hub Links branding",
            "WhatsApp support",
            "Advanced integrations",
            "Custom reports"
          ]
        }
      }
    }
  }
};
